import PhotoSwipeGallery from "./photoswipe/PhotoSwipeGallery";
import {preloadPhotoSwipeWhenIdle} from "./photoswipe/PhotoSwipeLoader";
import Overlay from "./Overlay";
import SliderStarter from "./slider/SliderStarter";
import Polyfill from "./Polyfill";
import {Helpers} from "../../common/js/Helpers";
import ThumbnailErrors from "./ThumbnailErrors";
import SingleImagePage from "./SingleImagePage";
import Imagelist from "./EventgalleryImageList";
import TilesCollection from "./EventgalleryTilesCollection";
import {whileParsing} from "./utils/whileParsing";

(function(Eventgallery){
	"use strict";

	// a thumbnail which does not load gets one more attempt and then its error state
	ThumbnailErrors.bind(document);

	/*
	 * The grids and the squares are laid out by the stylesheet alone
	 * (concepts/frontend-design.md, "Lists"). The justified rows of the image lists and the
	 * masonry of the tiles are drawn by the stylesheet until their scripts fill every row with
	 * whole images (EventgalleryImageList.js) and stack the tiles row by row into the shortest
	 * column (EventgalleryTilesCollection.js) - while the browser parses the page, as soon as
	 * the images of a list are in it, so nothing jumps on the screen. A list which a script
	 * adds later (an overlay) is laid out when the script says so.
	 */
	const layOutTheLists = () => {
		Imagelist.bind(document);
		TilesCollection.bind(document);
	};
	// Before the first tile is parsed: a tile waits hidden for its place (tiles-list.less). A
	// script which something moved behind the lists (the footer, async) finds tiles which are
	// painted already: they are stacked in the same task, so none is hidden for a frame.
	TilesCollection.announce(document);
	layOutTheLists();
	whileParsing(layOutTheLists);
	document.addEventListener('eventgallery-images-added', layOutTheLists);

	/*
	 * The lightbox: one click listener on the document, bound here before the body is parsed,
	 * opens it for a tap on a thumbnail as soon as the thumbnail is on the screen
	 * (PhotoSwipeGallery.onDocumentClick()); until the review of #1894 the thumbnails were bound
	 * at DOMContentLoaded, and a tap before it opened the file of the image. The hits of the
	 * images shown are counted from here as well; the configuration of the page follows this
	 * script in the head, so it is read when an image is shown.
	 */
	Eventgallery.lightbox = new PhotoSwipeGallery();
	document.addEventListener('click', (e) => Eventgallery.lightbox.onDocumentClick(e));
	// the library of the lightbox is a chunk: fetched while the browser idles after the load of
	// a page with a thumbnail of the lightbox; a tap before that loads it at once
	preloadPhotoSwipeWhenIdle();
	document.addEventListener('eventgallery-lightbox-changed', (data) => {
		const configuration = window.EventGalleryLightboxConfiguration;
		if (!configuration || !configuration.doTrackImageHits) {
			return;
		}
		fetch(configuration.trackImageHitsUrl, {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json'
			},
			body: JSON.stringify({'id': data.detail.id})
		})
			.catch(error => {
				console.error('Error while tracking event:', error);
			});
	});

	document.addEventListener('DOMContentLoaded', () =>{

		// the texts of the lightbox, and an address which names a slide opens it
		Eventgallery.lightbox.initPhotoSwipe();

        /**
		 * Single Image Page: the zoom button opens the lightbox of the big image, the arrow
		 * keys and a swipe over the photo lead to the neighbours (SingleImagePage.js)
         */
		Helpers.forEach(document.querySelectorAll('.singleimage-zoom'), (e) => {
			e.addEventListener('click', (e) => {
				e.preventDefault();
				document.getElementById('bigimagelink').click();
			})
		})
		SingleImagePage.bind(document);

        /*
         * The page sizes above the images of an event are links (snippets/event/inc/paging_top);
         * until 7.0.0 they were a select whose change this script submitted.
         */

        /**
		 * content overlay (example: checkout review page)
         */
		Helpers.forEach(document.querySelectorAll('a[data-eventgallery-overlay]'), (el) => {
			let contentId = el.getAttribute('href');
			el.addEventListener('click', (e) => {
				e.preventDefault();
				let overlay = new Overlay();
				overlay.openOverlay(document.getElementById(contentId.replace('#', '')).innerHTML);
			});
		})

        document.dispatchEvent(Polyfill.createNewEvent('eventgallery-images-added'));


        let sliderElements = document.querySelectorAll('div[data-slider="1"]');


        for(let i=0; i<sliderElements.length; i++) {
            let sliderStarter = new SliderStarter(sliderElements[i]);
            let timer = null;
            sliderStarter.start();

            window.addEventListener("resize", () => {
            	if (timer != null) {
            		clearTimeout(timer);
				}
            	timer = setTimeout(() => sliderStarter.start(), 1000);
            }, false);
        }

		/*
		 * An event card is a link by its markup (the link of its title is stretched over the
		 * card, the cover is a link of its own), so a click anywhere on it is a click on a link
		 * and Ctrl, Cmd, Shift and the middle button do what they do on every link. Until 7.0.0
		 * a click handler (data-eg-link) sent the browser to the event itself and lost them.
		 */
    }); //end domready
})(window.Eventgallery);
